import React, { forwardRef } from "react";

import { ITypographyProps, Typography } from "../Typography";

export interface IBodyProps {
  /** Font weight. */
  weight?: "regular" | "bold" | "medium";
}

export const Body1 = forwardRef<
  HTMLDivElement,
  IBodyProps & Omit<ITypographyProps, keyof IBodyProps | "variant">
>(({ weight = "regular", children, ...props }, ref) => {
  return (
    <Typography variant="Body 1" weight={weight} ref={ref} {...props}>
      {children}
    </Typography>
  );
});

Body1.displayName = "Body1";
